import React, {useEffect} from 'react';
// util imports 
import { trackPageView } from './utils/analytics';
// RTK Queries
import { useGetUserSessionQuery } from './services/api/userApi';
// React Router
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

// Components
import NavBar from './components/NavBar';
import { Chart, Filler } from 'chart.js';

// CSS
import './assets/styles/master.scss';

const App = () => {
    const navigate = useNavigate();
    const location = useLocation();
    Chart.register(Filler); // allows for the chart js graphs to have a filler
    const { data: userSessionData, isLoading: isUserSessionLoading, isError: isUserSessionError, isFetching: isUserSessionFetching } = useGetUserSessionQuery();
    
    // Protected route check
    useEffect(() => {
        const protectedRoutes = ['/profile', '/system-builder', '/systems', '/system', '/subscribed', '/upcoming-games', '/game-analyzer'];
        const isProtectedRoute = protectedRoutes.some(route => location.pathname.startsWith(route));
        if (!userSessionData?.isLoggedIn && isProtectedRoute && !isUserSessionFetching) {
            navigate('/');
        }
    }, [userSessionData, location, navigate]);

    // Track page views on route change
    useEffect(() => {
        trackPageView(location.pathname + location.search);
    }, [location]);

    return (
        <div className="flex flex-col h-screen overflow-hidden">
            <NavBar isLoggedIn={userSessionData?.isLoggedIn || false} isSubscribed={userSessionData?.isSubActive?.isActive || false}/>
            <main className="flex-1 overflow-hidden bg-white dark:bg-brand-dark-900 text-gray-900 dark:text-white transition-colors duration-300">
                <Outlet />
            </main>
        </div>
    );
};

export default App;